import * as Yup from 'yup';
import integrationAssetConfigs from '../IntegrationAssetForm/integrationAssetConfigs';

const validationMessage = {message: 'Not valid', exculdeEmptyString: true};

export default Yup.object().shape({
    assetType: Yup.string().required('Asset Type required'),
    timeStamp: Yup.date().optional(),
})